/* eslint-disable */
import React from 'react';
import cn from 'classnames';
import styles from './Payment.scss';
import { formatNumber } from 'utils'
import { useTranslation } from 'react-i18next';

const checkIcon = require('assets/images/icons/check-icon.svg');
const noIcon = require('assets/images/icons/icon-no.svg');

const checkIconPrint = require('assets/images/icons/check.svg');
const noIconPrint = require('assets/images/icons/icon-close.svg');

const digits = (number) => (number ? formatNumber(number) : 0);

const icon = (factor, print) => (
  <div className={styles.Image}>
    {print ?
        <img alt="icon" src={factor ? checkIconPrint : noIconPrint} />
        :
        <img alt="icon" src={factor ? checkIcon : noIcon} />
    }

  </div>
);

const Payment = ({ className, building, client, print }) => {
  const { t } = useTranslation();
  const { payment, instalment_payments_conditions, gas_surcharge_price,
    surcharge_balcony, surcharge_communications, surcharge_docs, surcharge_trash,
    balcony_surcharge_price, communications_surcharge_price, docs_surcharge_price,
    trash_surcharge_price } = building.data;
  const { ipoteka, military_ipoteka, mat_capital, installments } = payment;

  const arr = [
    {
      text: t('components.building.main.payment.ipoteka'),
      value: icon(ipoteka, print),
      check: ipoteka,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.installments'),
      subtext: instalment_payments_conditions,
      value: icon(installments, print),
      check: installments,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.military_ipoteka'),
      value: icon(military_ipoteka, print),
      check: military_ipoteka,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.mat_capital'),
      value: icon(mat_capital, print),
      check: mat_capital,
      shouldDisplay: true
    },
    {
      text: t('components.building.main.payment.surcharge_balcony'),
      value: t('components.building.main.payment.price', { price: formatNumber(balcony_surcharge_price) }),
      shouldDisplay: surcharge_balcony
    },
    {
      text: t('components.building.main.payment.surcharge_communications'),
      value: t('components.building.main.payment.price', { price: formatNumber(communications_surcharge_price) }),
      shouldDisplay: surcharge_communications
    },
    {
      text: t('components.building.main.payment.surcharge_docs'),
      value: t('components.building.main.payment.price', { price: formatNumber(docs_surcharge_price) }),
      shouldDisplay: surcharge_docs
    },
    {
      text: t('components.building.main.payment.surcharge_trash'),
      value: t('components.building.main.payment.price', { price: formatNumber(trash_surcharge_price) }),
      shouldDisplay: surcharge_trash
    }
  ];

  const gas = digits(gas_surcharge_price);
  if (gas !== 0) {
    arr.push({
      text: t('components.building.main.payment.gas'),
      value: <span>{t('components.building.main.payment.price', { price: gas })}</span>,
      shouldDisplay: true
    });
  }

  return (
    <div className={cn(styles.Payment, {[styles.Client]: client},  className, {[styles.PaymentPrint]: print})}>
      <h3 className={client ? styles.TitleClient : styles.Title}>
        {t('components.building.main.payment.pay')}
      </h3>
      <div className={client ? styles.InnerClient : styles.Inner}>
        {arr.map((row, index) => {
          if (row.shouldDisplay) {
            return (
              <div key={index} className={cn(styles.Row, ((row.text== 'Доплата за газ') ? styles.RowGas: null))}>
                <div className={cn(styles.Label, {[styles.LabelActive]: row.check})}>
                  <span>{row.text}</span>
                  {row.subtext ? <span className={styles.Subtext}>{row.subtext}</span> : null}
                </div>
                <div className={styles.Name}>
                  {row.value}
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default Payment;



// WEBPACK FOOTER //
// ./src/components/Building/Main/Payment/Payment.js